import lotsBasicDataDialog from './index.vue'; // 导入组件

lotsBasicDataDialog.install = (Vue) => {
    Vue.component(lotsBasicDataDialog.name, lotsBasicDataDialog);
};
export default lotsBasicDataDialog;
